module.exports = __webpack_public_path__ + "static/media/iconlog-2.26734aaa.png";